export default __webpack_public_path__ + "static/media/man-banner-thanks.9c6e2ba9.png";